import React, { useEffect, useState } from "react";
import api, { rupee } from "../../lib/api";
import { ShoppingCart } from "lucide-react";

export default function AdminAbandoned() {
  const [carts, setCarts] = useState([]);
  useEffect(() => { api.get("/admin/abandoned-carts").then((r) => setCarts(r.data)); }, []);
  return (
    <div data-testid="admin-abandoned">
      <h1 className="font-serif text-3xl text-navy mb-1">Abandoned Carts</h1>
      <p className="text-sm text-muted-foreground mb-6">Recovery-ready carts left before checkout. Recovery via email/WhatsApp architecture is prepared.</p>
      {carts.length === 0 ? (
        <div className="bg-white rounded-xl border border-black/5 p-12 text-center text-muted-foreground" data-testid="abandoned-empty"><ShoppingCart className="mx-auto mb-3 text-gold" size={30} />No abandoned carts tracked yet.</div>
      ) : (
        <div className="bg-white rounded-xl border border-black/5 overflow-x-auto">
          <table className="w-full min-w-[640px] text-sm">
            <thead className="bg-beige text-navy text-left"><tr><th className="p-3">Contact</th><th className="p-3">Items</th><th className="p-3">Cart Value</th><th className="p-3">Recovery</th><th className="p-3">When</th></tr></thead>
            <tbody>
              {carts.map((c) => (
                <tr key={c.id} className="border-t border-black/5 hover:bg-beige/40" data-testid={`abandoned-${c.id}`}>
                  <td className="p-3 text-navy">{c.phone || c.email || "Guest"}</td>
                  <td className="p-3 text-muted-foreground">{(c.items || []).length} item(s)</td>
                  <td className="p-3 font-medium text-navy">{rupee(c.cart_value)}</td>
                  <td className="p-3"><span className="text-xs bg-amber-100 text-amber-700 px-2 py-1 rounded-full capitalize">{c.recovery_status}</span></td>
                  <td className="p-3 text-muted-foreground">{new Date(c.created_at).toLocaleString("en-IN")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
